import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import choo1 from '../../../assets/assets-artsdao/img/choo1.jpg';
import choo2 from '../../../assets/assets-artsdao/img/choo2.jpg';
import choo3 from '../../../assets/assets-artsdao/img/choo3.jpg';
import choo4 from '../../../assets/assets-artsdao/img/choo4.jpg';
import choo5 from '../../../assets/assets-artsdao/img/choo5.jpg';
import choo6 from '../../../assets/assets-artsdao/img/choo6.jpg';

const clients = [
  { img: choo1, label: 'Edition, Downtown' },
  { img: choo2, label: 'Marsa Al Arab, Jumeirah' },
  { img: choo3, label: 'ME by Melia, Business Bay' },
  { img: choo4, label: 'FIVE, The palm' },
  { img: choo5, label: 'SLS Hotel, Business Bay' },
  { img: choo6, label: 'Indigo, Business Bay' },
];

const HotelsRecommend = () => {
  const swiperRef = useRef<any | null>(null);

  useEffect(() => {
    const handleClick = (e: any) => {
      if (!swiperRef.current) return;
      const swiper = swiperRef.current.swiper;
      const clickedSlide = e.target.closest('.swiper-slide');

      if (!clickedSlide) return;

      if (
        clickedSlide.classList.contains('swiper-slide-next') ||
        clickedSlide.classList.contains('swiper-slide-active')
      ) {
        swiper.slideNext();
      } else if (clickedSlide.classList.contains('swiper-slide-prev')) {
        swiper.slidePrev();
      }
    };

    const sliderElement = swiperRef.current;
    if (sliderElement) {
      sliderElement.addEventListener('click', handleClick);
    }

    return () => {
      if (sliderElement) {
        sliderElement.removeEventListener('click', handleClick);
      }
    };
  }, []);

  return (
    <div className="clients_choose">
      <div className="container">
        <h2 className="text-center font-inter lg:text-[32px] text-xl uppercase leading-normal font-semibold text-[#0f0f0f] my-11">
          Hotels we recommend in DUBAI
        </h2>
        <Swiper
          ref={swiperRef}
          modules={[Pagination]}
          loop={true}
          slidesPerView={3}
          centeredSlides={true}
          pagination={{ clickable: true, el: '.clients_choose_pagination' }}
          speed={0}
          breakpoints={{
            0: { slidesPerView: 1, loop: true },
            640: { slidesPerView: 1, centeredSlides: false, loop: true },
            992: { slidesPerView: 3, centeredSlides: true, loop: true },
          }}
          className="clients_choose_slider"
        >
          {clients.map((client, index) => (
            <SwiperSlide key={index}>
              <div className="clients_choose_item">
                <div className="clients_choose_item__img">
                  <img src={client.img} alt={client.label} />
                </div>
                <div className="clients_choose_item__label">
                  <span>{client.label}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="mt-10 w-full">
          <div className="pagination clients_choose_pagination flex items-center justify-center space-x-2"></div>

          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default HotelsRecommend;
